interface IndexItem {
  icon: string;
  title: string;
  count: string;
  desc: string;
}

const INDEX_ITEMS: IndexItem[] = [
  {
    icon: 'ri-fire-line',
    title: '热血战斗',
    count: '6,820部',
    desc: '燃到爆炸的战斗场面，主角逆袭的热血故事，肾上腺素飙升的必看类型。',
  },
  {
    icon: 'ri-heart-line',
    title: '恋爱甜宠',
    count: '5,430部',
    desc: '从校园纯爱到成人浪漫，甜到上头的恋爱漫画，少女心收割机。',
  },
  {
    icon: 'ri-ghost-line',
    title: '悬疑惊悚',
    count: '2,860部',
    desc: '烧脑反转、细思极恐，每一话都有悬念等你揭开，推理爱好者的狂欢。',
  },
  {
    icon: 'ri-emotion-laugh-line',
    title: '搞笑日常',
    count: '4,150部',
    desc: '笑到停不下来的沙雕日常，解压神器，心情不好的时候来一话。',
  },
  {
    icon: 'ri-rocket-line',
    title: '科幻奇幻',
    count: '3,240部',
    desc: '宏大世界观、天马行空的想象力，带你进入不可思议的异世界冒险。',
  },
  {
    icon: 'ri-sword-line',
    title: '武侠仙侠',
    count: '2,970部',
    desc: '江湖恩怨、修真飞升，国漫最具代表性的类型，侠义精神的传承。',
  },
  {
    icon: 'ri-basketball-line',
    title: '运动竞技',
    count: '1,580部',
    desc: '球场上奔跑的身影，竞技场上的巅峰对决，感受拼搏与友情的力量。',
  },
  {
    icon: 'ri-music-line',
    title: '都市生活',
    count: '3,710部',
    desc: '现代都市中的喜怒哀乐，职场、家庭、社交，最贴近生活的漫画类型。',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">主题索引</h2>
          <p className="text-foreground-500 text-sm mt-3">按类型快速浏览漫画，找到你最爱的品类</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group flex flex-col items-center p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer text-center"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <span className="text-xs text-accent-500 font-medium mb-2">{item.count}</span>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}